import { clinicParticipatesInKinnser } from './clinicKeyUtils';

export type ClinicEmrAgencyFlags = {
  is_kinnser_enabled?: boolean | null;
  is_rogeremr_enabled?: boolean | null;
};

export type ClinicEmrLabel = 'Kinnser' | 'RogerEMR';

export type ClinicEmrPillLabel = 'Roger Only';

type ClinicEmrLabelInput = {
  is_kinnser?: boolean;
  clinic_source?: string | null;
};

/**
 * User-facing EMR label for a clinic (EMR-375).
 * Kinnser-participating → Kinnser; otherwise RogerEMR.
 */
export function getClinicEmrLabelForClinic(
  clinic: ClinicEmrLabelInput | null | undefined
): ClinicEmrLabel {
  return clinicParticipatesInKinnser(clinic ?? undefined)
    ? 'Kinnser'
    : 'RogerEMR';
}

/**
 * Dropdown pill text for Roger-only clinics in dual-EMR agencies.
 * Kinnser-participating clinics get no pill (return null).
 */
export function getClinicRogerOnlyPillLabel(
  clinic: ClinicEmrLabelInput | null | undefined
): ClinicEmrPillLabel | null {
  if (!clinic || clinicParticipatesInKinnser(clinic)) return null;
  return 'Roger Only';
}

/**
 * Pills only when the agency has both integrations enabled (Internal Admin flags).
 * Null/undefined flags are treated as false.
 */
export function shouldShowClinicEmrPills(
  agency: ClinicEmrAgencyFlags | null | undefined
): boolean {
  return (
    agency?.is_kinnser_enabled === true && agency?.is_rogeremr_enabled === true
  );
}
